export const getSelectedDeparturePostalOperators = (state) =>
  state.postalOperatorSelector.departure.nodes
    .map((node) => ({
      ...node,
      children: node.children.filter((child) =>
        state.postalOperatorSelector.departure.checkedMailProcessingCenters.includes(
          child.value
        )
      ),
    }))
    .filter((node) => node.children && node.children.length);

export const getDeparturePostalOperators = (state) =>
  state.postalOperatorSelector.departure.nodes;
export const getDepartureOperators = (state) =>
  state.postalOperatorSelector.departure.nodesForOperator;
export const getDepartureCheckedMailProcessingCenters = (state) =>
  state.postalOperatorSelector.departure.checkedMailProcessingCenters;
export const getDepartureCheckedOperator = (state) =>
  state.postalOperatorSelector.departure.checkedOperator;
export const getSelectedDepartureOperators = (state) =>
  (state.postalOperatorSelector.departure.nodesForOperator || []).filter(
    (node) => getDepartureCheckedOperator(state).includes(node.value)
  );
export const getExpandedDeparturePostalOperators = (state) =>
  state.postalOperatorSelector.departure.expandedPostalOperators;
export const getExpandedDeparturePostalOperatorsOperatorImpcAdmin = (state) =>
  state.postalOperatorSelector.departure
    .expandedPostalOperatorsOperatorImpcAdmin;
export const getDepartureIMPCSelections = (state) =>
  state.postalOperatorSelector.departure.selections;
export const getDeparturePostalOperatorIsLoading = (state) =>
  state.postalOperatorSelector.departure.isLoading;

export const getSelectedArrivalPostalOperators = (state) =>
  state.postalOperatorSelector.arrival.nodes
    .map((node) => ({
      ...node,
      children: node.children.filter((child) =>
        state.postalOperatorSelector.arrival.checkedMailProcessingCenters.includes(
          child.value
        )
      ),
    }))
    .filter((node) => node.children && node.children.length);

export const getArrivalPostalOperators = (state) =>
  state.postalOperatorSelector.arrival.nodes;
export const getArrivalOperators = (state) =>
  state.postalOperatorSelector.arrival.nodesForOperator;
export const getArrivalCheckedMailProcessingCenters = (state) =>
  state.postalOperatorSelector.arrival.checkedMailProcessingCenters;
export const getArrivalCheckedOperator = (state) =>
  state.postalOperatorSelector.arrival.checkedOperator;
export const getSelectedArrivalOperators = (state) =>
  (state.postalOperatorSelector.arrival.nodesForOperator || []).filter((node) =>
    getArrivalCheckedOperator(state).includes(node.value)
  );
export const getExpandedArrivalPostalOperators = (state) =>
  state.postalOperatorSelector.arrival.expandedPostalOperators;
export const getArrivalIMPCSelections = (state) =>
  state.postalOperatorSelector.arrival.selections;
export const getArrivalPostalOperatorIsLoading = (state) =>
  state.postalOperatorSelector.arrival.isLoading;

export const getDirections = (state) => state.postalOperatorSelector.directions;
export const getIsDirectionsSwitched = (state) =>
  state.postalOperatorSelector.directions.switched;

export const getTrafficCheckedOperator = (state) =>
  state.postalOperatorSelector.traffic.checkedOperator;

export const getTrafficOperatorNodes = (state) =>
  state.postalOperatorSelector.traffic.nodesForOperator;
